import { PLANNER_STRUCT_TYPE } from "components/controls/select/SelectorPlannerShowH"
import { GraphGroup } from "components/planner/types"
import querySo from "stores/route/query"
import { URL_PAR, URL_PAR_PLANNER_LAYER } from "stores/route/utils/types"
import { Cycle } from "types/Cycle"
import { GrowUnit } from "types/GrowUnit"
import { buildGrowUnitsGroup, buildPhasesAndGrowUnitGroup } from "./growUnitsGroup"



/** 
 * crea il GROWING-GROUP per dei CYCLES  
 * raggruppati per GROW-UNIT
 * */
export function buildGrowUnitsCyclesGroup(cycles: Cycle[], growUnits: GrowUnit[]): GraphGroup {
	const structType = querySo.getSearchUrl(URL_PAR.PLANNER_STRUCT) as PLANNER_STRUCT_TYPE ?? PLANNER_STRUCT_TYPE.BY_GUS
	const layerUrl = querySo.getSearchUrl(URL_PAR.PLANNER_LAYER) as URL_PAR_PLANNER_LAYER ?? URL_PAR_PLANNER_LAYER.DEFAULT
	const showLayersDisabled = layerUrl == URL_PAR_PLANNER_LAYER.ALL
	const showOnlyOccupied = layerUrl == URL_PAR_PLANNER_LAYER.ONLY_OCCUPIED
	const onlyLayers = showOnlyOccupied 
		? buildOccupiedLayersSet(cycles)
		: null 
	let group: GraphGroup = null

	if (structType == PLANNER_STRUCT_TYPE.BY_GUS) {
		group = buildGrowUnitsGroup(
			growUnits,
			cycles,
			showLayersDisabled,
			onlyLayers,
		)
		
	} else if (structType == PLANNER_STRUCT_TYPE.BY_PHASES) {
		group = buildPhasesAndGrowUnitGroup(
			growUnits, 
			cycles, 
			showLayersDisabled, 
			onlyLayers
		)
	}

	return group
}



/**
 * Crea un SET di chiavi "${growUnitId}_${layerNumber}" 
 * per tutti i LAYER occupati da almeno un CYCLE
 */
function buildOccupiedLayersSet(cycles: Cycle[]): Set<string> {
	const occupied = new Set<string>()
	for (const cycle of cycles) {
		if (!cycle.layers) continue
		for (const layer of cycle.layers) {
			const guId = layer.growUnitId ?? cycle.growUnitId
			if (guId != null && layer.layerNumber != null) {
				occupied.add(`${guId}_${layer.layerNumber}`)
			}
		}
	}
	return occupied
}